import { serializable, alias, list, object, primitive } from 'serializr';

export class ScopeWasteType {
  @serializable
  id?: number;

  @serializable(alias('treatment_method', primitive()))
  treatmentMethod?: string | null = null;

  @serializable(alias('waste_type_id', primitive()))
  wasteTypeId?: number | null = null;

  @serializable(alias('total_waste_produced', primitive()))
  totalWasteProduced?: number | null = null;
}

export class ScopeThreeData {
  @serializable(alias('products_total_weight', primitive()))
  productsTotalWeight?: number;

  @serializable(alias('total_waste_water', primitive()))
  totalWasteWater?: number;

  @serializable(alias('total_waste_produced', primitive()))
  totalWasteProduced?: number;

  @serializable(alias('waste_diversion_rate', primitive()))
  wasteDiversionRate?: number | null;

  @serializable(alias('scope_waste_type', list(object(ScopeWasteType))))
  scopeWasteType?: ScopeWasteType[];
}
